import { render, staticRenderFns } from "./BillPayment.vue?vue&type=template&id=5d531dd6&scoped=true&"
import script from "./BillPayment.vue?vue&type=script&lang=js&"
export * from "./BillPayment.vue?vue&type=script&lang=js&"
import style0 from "./BillPayment.vue?vue&type=style&index=0&id=5d531dd6&scoped=true&lang=css&"
import style1 from "./BillPayment.vue?vue&type=style&index=1&id=5d531dd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d531dd6",
  null
  
)

export default component.exports